import React from 'react';

import { colors } from 'styles/theme/colors';

interface PublishIconOutlinedProps {
  stroke?: string;
  size?: number;
}

const PublishIconOutlined: React.FC<PublishIconOutlinedProps> = ({ stroke = colors.black50, size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7 8.5V3.5' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' />
      <path d='M5 5.5L7 3.5L9 5.5' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' />
      <path d='M5 10.5H9' stroke={stroke} strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M1.5 1.5V12.5C1.5 13.0523 1.94771 13.5 2.5 13.5H11.5C12.0523 13.5 12.5 13.0523 12.5 12.5V4L9 0.5H2.5C1.94772 0.5 1.5 0.947715 1.5 1.5Z'
        stroke={stroke}
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PublishIconOutlined;
